import { render } from "./EditPersonalDataModal.vue?vue&type=template&id=3d4b817a&scoped=true"
import script from "./EditPersonalDataModal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditPersonalDataModal.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditPersonalDataModal.vue?vue&type=style&index=0&id=3d4b817a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4b817a"]])

export default __exports__